<template>
   <v-container class="mt-5">
     <v-card class="rounded-lg">
      <v-card-text>
        <v-simple-table>
          <thead :style="'background-color:' + darkModeBackground + '; height: 60px;'">
            <tr>
              <th><h5 style="color:#092C4C" class="text-center font-weight-bold">{{ languageSelect === 0 ? "หมายเลขคิว" : "Number" }}</h5></th>
              <th><h5 style="color:#092C4C" class="text-center font-weight-bold">{{ languageSelect === 0 ? "ช่องบริการ" : "Counter" }}</h5></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in 6"
               :key="index">
              <td :style="'height: 60px;'"> <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2"> {{ bookingUse.length >= index ? bookingUse[index - 1].storeFrontQueue : '' }}</h5> </td>
              <td :style="'height: 60px;'"><h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{
            bookingUse.length >= index
              ? (bookingUse[index - 1].servicePoint || (bookingUse[index - 1].statusBt === 'confirmJob' ? 'เรียกคิว' : ''))
              : ''
          }}</h5></td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    darkModeBackground: {
      type: String,
      default: '#FFFFFF'
    },
    bookingUse: {
      type: Array,
      default: () => []
    },
    languageSelect: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped>
.service{
min-height: 5vh;
}
.none-service{
min-height: 5vh;
}
.text-Header, .text-sub, .text-service{
font-weight: 700;
}
.text-service {
font-size: 5vw;
}
.text-sub{
font-size: 3vw;
}
.row-service{
border-radius: 20px;
box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.4);
overflow: hidden;
background-color: #E9E9E9;
border: 3px solid #BDE56A;
}
</style>



// WEBPACK FOOTER //
// src/components/OhRich/QueseBooking.vue